module.exports = __webpack_public_path__ + "static/img/30008 (4).0387f5e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30008 (4).webp
// module id = CyHQ
// module chunks = 14